import React, { useEffect, useState } from "react"
import { MobergColumn, MobergDropdown, MobergInputLabel, MobergNumberInput } from "../../../../../../../Moberg"
import { Analytic, CPPOptFlexAnalysis } from "../../../Types/AnalysisDetails"
import { validatePRxThreshold } from "../../Visualizations/CPPOpt/validation"
import { useTraceOptions } from "./useTraceOptions"
import { equalsTraceOptionOrString } from "../../../utils"

type EditCPPOptFlexProps = {
	initialState: CPPOptFlexAnalysis
	onChange: (analysis: CPPOptFlexAnalysis) => void
}

export const EditCPPOptFlex: React.FC<EditCPPOptFlexProps> = ({ initialState, onChange }) => {
	const traceOptions = useTraceOptions()
	const [ABP, setABPModality] = useState<string>(initialState.ABP)
	const [ICP, setICPModality] = useState<string>(initialState.ICP)
	const [prxThreshold, setPRxThreshold] = useState<number>(initialState.prxThreshold)

	useEffect(() => {
		onChange({
			...initialState,
			analytic: Analytic.CPPOpt_FLEX,
			ABP,
			ICP,
			prxThreshold,
			calculationWindowMs: 8 * 60 * 60 * 1000,
			calculationPeriodMs: 60 * 1000
		})
	})

	return (
		<MobergColumn gap="16px">
			<MobergColumn gap="8px">
				<MobergInputLabel text={"ABP"} />

				<MobergDropdown
					options={traceOptions}
					onChange={newValue => setABPModality(newValue.rawDataKey)}
					selectedValue={ABP}
					equals={equalsTraceOptionOrString}
				/>
			</MobergColumn>

			<MobergColumn gap="8px">
				<MobergInputLabel text={"ICP"} />

				<MobergDropdown
					options={traceOptions}
					onChange={newValue => setICPModality(newValue.rawDataKey)}
					selectedValue={ICP}
					equals={equalsTraceOptionOrString}
				/>
			</MobergColumn>

			<MobergColumn gap="8px">
				<MobergInputLabel text={"PRx threshold for autoregulation"} />

				<MobergNumberInput
					defaultValue={0.25}
					value={prxThreshold}
					validationFunction={validatePRxThreshold}
					onChange={threshold => { setPRxThreshold(threshold as number) }}
				/>
			</MobergColumn>
		</MobergColumn>
	)
}
